var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base_objects',{ref:"objects",attrs:{"essence":"Объект-аналог","essence_name_for_plural_others":"объектов-аналогов","service":_vm.service,"single_element_url":"expensives","keys_if_all_attrs_hidden":[
		'attrs.expensive_code',
		'attrs.expensive_unit_type',
		'attrs.expensive_name',
		'attrs.expensive_unit_type_count',
		'attrs.expensive_cost_on_date_for_area',
		'attrs.expensive_cost_on_date_for_volume'
	],"without_edit_many":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }